import { useEffect, useState, useMemo } from 'react';
import moment from 'moment-timezone';

const useRealtimeClock = ({
  format = '24-hour',
  interval = 1000,
  timezone = 'Asia/Seoul',
} = {}) => {
  const getTime = () => {
    const now = moment().tz(timezone);
    return {
      hours: now.format(format === '24-hour' ? 'HH' : 'hh'),
      minutes: now.format('mm'),
      seconds: now.format('ss'),
    };
  };

  const [time, setTime] = useState(getTime());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getTime());
    }, interval);

    return () => clearInterval(timer);
  }, [interval, timezone, format]);

  const formattedTime = useMemo(() => {
    const { hours, minutes, seconds } = time;
    const pad = (num) => String(num).padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }, [time]);

  return { formattedTime, ...time };
};

export default useRealtimeClock;